import {
  Card,
  CardBody,
  Stat,
  StatNumber,
  StatLabel,
  HStack,
  VStack,
  Text,
  Icon,
  useColorModeValue,
  Badge,
} from '@chakra-ui/react'
import { LucideIcon } from 'lucide-react'

interface StatCardWithBreakdownProps {
  title: string
  value: number | string
  icon: LucideIcon
  color?: string
  isLoading?: boolean
  breakdown?: {
    active?: number
    inactive?: number
    deleted?: number
  }
}

export function StatCardWithBreakdown({
  title,
  value,
  icon,
  color = 'blue',
  isLoading = false,
  breakdown,
}: StatCardWithBreakdownProps) {
  const textColor = useColorModeValue('gray.600', 'gray.300')
  const mutedColor = useColorModeValue('gray.500', 'gray.400')

  return (
    <Card>
      <CardBody>
        <HStack justify="space-between" align="flex-start">
          <VStack align="flex-start" spacing={2} flex={1}>
            <Text fontSize="sm" color={textColor} fontWeight="medium">
              {title}
            </Text>
            <Stat>
              <StatNumber fontSize="2xl" fontWeight="bold">
                {isLoading ? '...' : typeof value === 'number' ? value.toLocaleString() : value}
              </StatNumber>
            </Stat>
            {breakdown && !isLoading && (
              <HStack spacing={2} flexWrap="wrap" mt={1}>
                {breakdown.active !== undefined && breakdown.active > 0 && (
                  <Badge colorScheme="green" fontSize="2xs">
                    {breakdown.active} active
                  </Badge>
                )}
                {breakdown.inactive !== undefined && breakdown.inactive > 0 && (
                  <Badge colorScheme="gray" fontSize="2xs">
                    {breakdown.inactive} inactive
                  </Badge>
                )}
                {breakdown.deleted !== undefined && breakdown.deleted > 0 && (
                  <Badge colorScheme="red" fontSize="2xs" variant="outline">
                    {breakdown.deleted} deleted
                  </Badge>
                )}
              </HStack>
            )}
          </VStack>
          <Icon as={icon} boxSize={8} color={`${color}.500`} opacity={0.8} />
        </HStack>
      </CardBody>
    </Card>
  )
}
